import { useContext, useMemo } from 'react'

import { InstitutionContext } from '../Providers/InstitutionProvider'
import { isArray } from 'lodash'
import { InstitutionOptions } from '../utils/constants'
import { GlobalContext } from '../Providers/GlobalProvider'

const useBetaMode = () => {
  const iContext = useContext(InstitutionContext)
  const { betaMode } = useContext(GlobalContext)

  const active = useMemo(() => {
    let use = betaMode.active

    if (!use && iContext !== undefined && isArray(iContext.institutionOptions)) {
      const betaOption = iContext.institutionOptions.find(option => option.optionType.type === InstitutionOptions.BETA_MODE)

      if (betaOption) {
        use = betaOption.optionEnabled
      }
    }

    return use
  }, [betaMode.active, iContext?.institutionOptions])

  return { active }
}

export default useBetaMode
